module.exports = __webpack_public_path__ + "04_mole.738b1a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/04_mole.png
// module id = nWgb
// module chunks = 0